import * as actions from "../actions/actions";
import { connect } from "react-redux";
import browserHistory from "../helpers/history";

import React from "react";

import Carousel from "./nounproject-carousel";
let COLORS = require("../constants/colors").COLORS;

class ForEdu extends React.Component {
    checkUserAuth(e) {
        e.preventDefault();
        if (this.props.currentUser.is_anonymous) {
            window.location.href = "/for-edu/login/";
        } else {
            window.location.href = "/for-edu/apply/";
        }
    }

    constructor(props) {
        super(props);
        let testimonialData = [
            {
                name: "Tony Vincent",
                title: "Learning & Technology Consultant",
                location: "Council Bluffs, IA",
                quote:
                    "Noun Project helps me illustrate instructional materials with images that are immediately recognizable. One of my favorite uses for The Noun Project's icons is to use them to visually reinforce each item in a bulleted list.",
                imageName: "tony_vincent_headshot.png"
            },
            {
                name: "Lisa Johnson",
                title: "Educational Technologist",
                location: "Westlake High School in Austin, TX",
                quote:
                    "I have been a bit of a Noun Project junkie for several years. I am a firm believer that in this ever visual world... dual coding (pairing text with visuals) is key. Thus, I use Noun Project icons in my slide decks, infographics, handouts, and even my <a href='http://a.co/cmMZ9Rk' target='_blank'>book</a>.",
                imageName: "lisa_johnson_headshot.png"
            },
            {
                name: "Greg Bem",
                title: "Faculty Librarian",
                location:
                    "Lake Washington Institute of Technology, Kirkland, WA",
                quote:
                    "Noun Project is not only a fantastic resource for providing superb visual content that can be used in accessible and practical ways, but it's a great platform for teaching and learning about open licenses and new flows of information and art in the digital frontier.",
                imageName: "greg_bem_headshot.png"
            },
            {
                name: "Ryan O'Donnell",
                title: "Technology TOSA",
                location: "Rocklin Unified School District, Rocklin, CA",
                quote:
                    "I use Noun Project for virtually all my presentations no matter the subject area. Also, when showing teachers how to make their own newsletters, infographics and other digital storytelling ideas, it is THE “go to” place for icons… because I'm sorry but the 90's called and clip art is dead.",
                imageName: "ryan_odonnell_headshot.png"
            },
            {
                name: "Anke Tröder",
                title: "Public Speaking & Presenting Coach",
                location:
                    "University of Applied Sciences & Arts, Hildesheim, Germany",
                quote:
                    "I teach public speaking at a small German college and help coach student start-ups. I use my Noun Project Pro account for pretty much everything in class: slides, hand-outs, posters, evaluation tools.",
                imageName: "anke_troder_headshot.png"
            },
            {
                name: "Andrew Ellingsen",
                title: "Elementary Music Teacher and Instructional Coach",
                location: "John Cline Elementary, Decorah, IA",
                quote:
                    "I use Noun Project when building visuals and manipulatives for students to use in the music classroom. The clear icons that are easy to manipulate make it so simple to customize resources for my lessons!",
                imageName: "andrew_ellingsen_headshot.png"
            },
            {
                name: "Peter Pappas",
                title: "Adjunct Instructor",
                location: "University of Portland, Portland, OR",
                quote:
                    "My university students and I have published 18 multi-touch books on <a href='https://itunes.apple.com/us/author/peter-pappas/id569306821?mt=11' target='_blank' >iTunes</a>. Noun Project icons are perfect for use with iBooks Author. They provide the reader with non-verbal cues on how to manipulate the interactive widgets.",
                imageName: "peter_pappas_headshot.png"
            },
            {
                name: "Trisha Sanchez",
                title: "Technology Teacher",
                location: "Natomas Charter School, Sacramento, CA",
                quote:
                    "I love using Noun Project to add icons to my class instructions, resources and Hyperdocs. I also love using the icons in my professional presentations. I can always find the kind of icon I’m looking for and now I can change colors to match the color themes of my designs.",
                imageName: "trisha_sanchez_headshot.png"
            }
        ];

        // Shuffle this array so you get new testimonials each time
        this.shuffle(testimonialData);

        this.props.getCurrentUser();

        this.state = {
            priceInDollars: "19",
            priceInCents: "99",
            testimonialData: testimonialData
        };
    }

    render() {
        let applicationList = this.renderAppList(),
            educators = this.renderEducators(),
            students = this.renderStudents(),
            header = this.renderHeader(),
            pleanFeatures = this.renderPlanFeatures(),
            testimonials = this.renderTestimonials(),
            commonQuestions = this.renderCommonQuestions();

        return (
            <div style={{ minHeight: "100%" }}>
                <style>{`
                        @media (max-width: 768px) {
                            .page-header .row{
                                flex-direction: column-reverse;
                            }
                        }
                            `}</style>
                {header}
                <section
                    className="plan-features"
                    style={{
                        background: COLORS.$white,
                        color: COLORS.$black,
                        minHeight: "100%"
                    }}
                >
                    <div className="container">
                        {pleanFeatures}
                        {applicationList}
                        {educators}
                    </div>
                    {testimonials}
                    <div className="container">
                        {students}
                        {commonQuestions}
                    </div>
                </section>
            </div>
        );
    }

    renderAppList() {
        let appList;

        appList = (
            <span>
                <div className="list-of-apps-header">
                    Plus all of our apps for
                </div>
                <ul className="list-of-apps margin-b-xl row">
                    <li className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <ul>
                            <li>
                                <a className="display-flex" href="/for-mac">
                                    <img
                                        src={require("../../img/mac_app/apple@2x.png")}
                                        alt="Noun Project for Mac"
                                        title="Drag and drop from your desktop."
                                        width="24"
                                        height="24"
                                    />{" "}
                                    Mac Users
                                </a>
                            </li>
                            <li>
                                <a className="display-flex" href="/for-google">
                                    <img
                                        src={require("../../img/for_windows/logo_slides_128px.png")}
                                        alt="Noun Project for Google Slides"
                                        width="24"
                                        height="24"
                                    />{" "}
                                    Google Slides
                                </a>
                            </li>
                            <li>
                                <a className="display-flex" href="/for-google">
                                    <img
                                        src={require("../../img/for_windows/logo_docs_128px.png")}
                                        alt="Noun Projeft for Google Docs"
                                        width="24"
                                        height="24"
                                    />{" "}
                                    Google Docs
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <ul>
                            <li>
                                <a className="display-flex" href="/for-adobe">
                                    <img
                                        src={require("../../img/for_windows/appicon_illustrator@2x.png")}
                                        alt="Noun Project for Adobe Illustrator"
                                        width="24"
                                        height="24"
                                    />{" "}
                                    Adobe Illustrator
                                </a>
                            </li>
                            <li>
                                <a className="display-flex" href="/for-adobe">
                                    <img
                                        src={require("../../img/for_windows/appicon_photoshop@2x.png")}
                                        alt="Noun Project for Adobe Photoshop"
                                        width="24"
                                        height="24"
                                    />{" "}
                                    Adobe Photoshop
                                </a>
                            </li>
                            <li>
                                <a className="display-flex" href="/for-adobe">
                                    <img
                                        src={require("../../img/for_windows/appicon_indesign@2x.png")}
                                        alt="Noun Project for Adobe InDesign"
                                        width="24"
                                        height="24"
                                    />{" "}
                                    Adobe InDesign
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <ul>
                            <li>
                                <a className="display-flex" href="/for-office">
                                    <img
                                        src={require("../../img/for_windows/Microsoft_PowerPoint_2013_logo.svg")}
                                        alt="Noun Project for Microsoft PowerPoint"
                                        width="24"
                                        height="24"
                                    />{" "}
                                    Microsoft PowerPoint
                                </a>
                            </li>
                            <li>
                                <a className="display-flex" href="/for-office">
                                    <img
                                        src={require("../../img/for_windows/Microsoft_Word_2013_logo.svg")}
                                        alt="Noun Project for Microsoft Word"
                                        width="24"
                                        height="24"
                                    />{" "}
                                    Microsoft Word
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </span>
        );

        return appList;
    }

    renderHeader() {
        let header;

        header = (
            <header
                className="page-header"
                style={{
                    textAlign: "left",
                    background: COLORS.$almostblack,
                    color: COLORS.$offwhite,
                    paddingTop: "20px",
                    paddingBottom: "60px",
                    minHeight: "450px"
                }}
            >
                <div className="container">
                    <ul className="row">
                        <li className="page-header-text-box col-lg-6 col-sm-6 col-xs-12">
                            <h1 className="font-xxlarge weight-medium margin-t-xl">
                                Icons for <br />
                                Education
                            </h1>
                            <p className="font-large weight-light">
                                Educators, students and edu staff get all the
                                benefits of NounPro at half the cost.
                            </p>
                            <p>Must apply to receive discount</p>
                            <a
                                className="button blue"
                                title="Apply for discount"
                                style={{ margin: "24px 0" }}
                                onClick={this.checkUserAuth.bind(this)}
                            >
                                Apply for discount
                            </a>
                        </li>
                        <li
                            className="plan-type plan-pro col-lg-6 col-sm-6 col-xs-12 margin-t-xxl"
                            style={{
                                color: COLORS.$white,
                                textAlign: "center"
                            }}
                        >
                            <img
                                alt="NounPro"
                                src={require("../../img/for_edu/nounpro_edu_apple@2x.png")}
                                width="50"
                                height="50"
                            />
                            <h3 className="font-xxlarge">NounPro</h3>
                            <h3 className="font-large">Icons For Education</h3>
                            <div className="price-container">
                                <div className="price-sign-style">
                                    <div className="price-dollar-sign">$</div>
                                    <div className="price-dollars-bold">
                                        {this.state.priceInDollars}
                                    </div>
                                    <div className="price-cents-underline price-pro">
                                        {this.state.priceInCents}
                                    </div>
                                    <div className="price-stacked-type">
                                        billed yearly
                                    </div>
                                </div>
                                <div
                                    className="font-small color-grey margin-t-m"
                                    style={{ textDecoration: "line-through" }}
                                >
                                    $39.99 per yr
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </header>
        );

        return header;
    }

    renderPlanFeatures() {
        require("../../sass/components/plan-features.sass");

        let planFeatures;

        planFeatures = (
            <div className="comparison-info">
                <h3>Here’s what you get</h3>
                <ul className="row">
                    <li className="pricing-features col-lg-3 col-sm-3 col-xs-6">
                        <img
                            className="pricing-illustration"
                            src={require("../../img/pricing/pricing_illustration_lots_of_icons@2x.png")}
                            alt="Over 1 Million Icons"
                        />
                        <div>
                            Over 1<br /> Million Icons
                        </div>
                    </li>
                    <li className="pricing-features col-lg-3 col-sm-3 col-xs-6">
                        <img
                            className="pricing-illustration"
                            src={require("../../img/pricing/pricing_illustration_royaltyfree_licenses@2x.png")}
                            alt="Royalty-free Licenses"
                        />
                        <div>
                            Royalty—free
                            <br /> Licenses
                        </div>
                    </li>
                    <li className="pricing-features col-lg-3 col-sm-3 col-xs-6">
                        <img
                            className="pricing-illustration"
                            src={require("../../img/pricing/pricing_illustration_change_color@2x.png")}
                            alt="Change Color"
                        />
                        <div>
                            Customize Color
                            <br /> and Background
                        </div>
                    </li>
                    <li className="pricing-features col-lg-3 col-sm-3 col-xs-6">
                        <img
                            className="pricing-illustration"
                            src={require("../../img/pricing/pricing_illustration_svg_and_png@2x.png")}
                            alt="SVG &amp; PNG"
                        />
                        <div>
                            SVG &amp; PNG
                            <br /> Files
                        </div>
                    </li>
                </ul>
            </div>
        );

        return planFeatures;
    }

    renderEducators() {
        let educators;

        educators = (
            <div>
                <div className="row margin-t-xl column-reverse-on-mobile">
                    <div className="col-lg-6 col-sm-6 col-xs-12">
                        <h2 className="font-large weight-medium margin-t-xxl">
                            Educators
                        </h2>
                        <p className="font-large weight-light">
                            Here are a few creative ways
                            <br /> to use icons in your work
                        </p>
                    </div>
                    <div className="col-lg-6 col-sm-6 col-xs-12">
                        <img
                            src={require("../../img/for_edu/educator_illustration@2x.png")}
                            alt="Educators illustration"
                            width="100%"
                        />
                    </div>
                </div>
                <style>
                    {`.idea-list-point{
                        align-items: center;
                        justify-content: flex-start;
                    }
                    `}
                </style>
                <ul className="row  margin-t-xl">
                    <li className="idea-list-point display-flex col-lg-4 col-md-4 col-sm-6 col-xs-6">
                        <img
                            className="margin-r-m"
                            src={require("../../img/for_edu/edu_brainstorm@2x.png")}
                            width="40"
                            height="40"
                        />
                        <p className="weight-medium">
                            Combine different icons to brainstorm new story
                            ideas
                        </p>
                    </li>
                    <li className="idea-list-point display-flex col-lg-4 col-md-4 col-sm-6 col-xs-6">
                        <img
                            className="margin-r-m"
                            src={require("../../img/for_edu/edu_lists@2x.png")}
                            width="40"
                            height="40"
                        />
                        <p className="weight-medium">
                            Create a behavior  <br />
                            checklist
                        </p>
                    </li>
                    <li className="idea-list-point display-flex col-lg-4 col-md-4 col-sm-6 col-xs-6">
                        <img
                            className="margin-r-m"
                            src={require("../../img/for_edu/edu_newsletter@2x.png")}
                            width="40"
                            height="40"
                        />
                        <p className="weight-medium">
                            Use in communication with other educators and
                            parents
                        </p>
                    </li>
                    <li className="idea-list-point display-flex col-lg-4 col-md-4 col-sm-6 col-xs-6">
                        <img
                            className="margin-r-m"
                            src={require("../../img/for_edu/edu_daily_schedule@2x.png")}
                            width="40"
                            height="40"
                        />
                        <p className="weight-medium">
                            Illustrate a daily or classroom schedule for
                            non–readers
                        </p>
                    </li>
                    <li className="idea-list-point display-flex col-lg-4 col-md-4 col-sm-6 col-xs-6">
                        <img
                            className="margin-r-m"
                            src={require("../../img/for_edu/edu_charts@2x.png")}
                            width="40"
                            height="40"
                        />
                        <p className="weight-medium">
                            Add icons to infographics, presentations or your
                            blog
                        </p>
                    </li>
                    <li className="idea-list-point display-flex col-lg-4 col-md-4 col-sm-6 col-xs-6">
                        <img
                            className="margin-r-m"
                            src={require("../../img/for_edu/edu_wayfinding@2x.png")}
                            width="40"
                            height="40"
                        />
                        <p className="weight-medium">
                            Create way–finding signs to help students get around
                            your school
                        </p>
                    </li>
                    <li className="idea-list-point display-flex col-lg-4 col-md-4 col-sm-6 col-xs-6">
                        <img
                            className="margin-r-m"
                            src={require("../../img/for_edu/edu_sentence_structure@2x.png")}
                            width="40"
                            height="40"
                        />
                        <p className="weight-medium">
                            Teach sentence <br />
                             structure
                        </p>
                    </li>
                    <li className="idea-list-point display-flex col-lg-4 col-md-4 col-sm-6 col-xs-6">
                        <img
                            className="margin-r-m"
                            src={require("../../img/for_edu/edu_dictionary@2x.png")}
                            width="40"
                            height="40"
                        />
                        <p className="weight-medium">
                            Ask students to build their own dictionary
                        </p>
                    </li>
                    <li className="idea-list-point display-flex col-lg-4 col-md-4 col-sm-6 col-xs-6">
                        <img
                            className="margin-r-m"
                            src={require("../../img/for_edu/edu_translate@2x.png")}
                            width="40"
                            height="40"
                        />
                        <p className="weight-medium">
                            Help students in ESL learn new&nbsp;words
                        </p>
                    </li>
                </ul>
                <div
                    className="margin-t-xl"
                    style={{
                        textAlign: "center"
                    }}
                >
                    <a
                        href="https://www.surveymonkey.com/r/5PVPTPZ"
                        target="_blank"
                        className="text-link"
                    >
                        Tell us how you use Noun Project in your classroom
                    </a>
                </div>
            </div>
        );

        return educators;
    }

    renderStudents() {
        let students;

        students = (
            <div style={{ borderTop: "solid 1px #ccc" }}>
                <div className="row  margin-t-xl column-reverse-on-mobile">
                    <div className="col-lg-6 col-sm-6 col-xs-12">
                        <h2 className="font-large weight-medium margin-t-xxl">
                            Students
                        </h2>
                        <p className="font-large weight-light">
                            Here are a few ideas for how to
                            <br /> use icons in your projects
                        </p>
                    </div>
                    <div className="col-lg-6 col-sm-6 col-xs-12">
                        <img
                            src={require("../../img/for_edu/student_illustration@2x.png")}
                            alt="Students illustration"
                            width="100%"
                        />
                    </div>
                </div>
                <style>
                    {`.idea-list-point{
                        align-items: center;
                        justify-content: flex-start;
                        padding: 8px 24px;
                    }
                    `}
                </style>
                <ul className="row margin-t-xl">
                    <li className="idea-list-point display-flex col-lg-4 col-md-4 col-sm-6 col-xs-6">
                        <img
                            className="margin-r-m"
                            src={require("../../img/for_edu/stu_presentation@2x.png")}
                            width="40"
                            height="40"
                        />
                        <p className="weight-medium">
                            Add icons to your <br />
                            class presentations
                        </p>
                    </li>
                    <li className="idea-list-point display-flex col-lg-4 col-md-4 col-sm-6 col-xs-6">
                        <img
                            className="margin-r-m"
                            src={require("../../img/for_edu/edu_art@2x.png")}
                            width="40"
                            height="40"
                        />
                        <p className="weight-medium">
                            Find inspiration for your <br />
                            next art project
                        </p>
                    </li>
                    <li className="idea-list-point display-flex col-lg-4 col-md-4 col-sm-6 col-xs-6">
                        <img
                            className="margin-r-m"
                            src={require("../../img/for_edu/stu_newspaper@2x.png")}
                            width="40"
                            height="40"
                        />
                        <p className="weight-medium">
                            Add visuals to your school newspaper
                        </p>
                    </li>
                    <li className="idea-list-point display-flex col-lg-4 col-md-4 col-sm-6 col-xs-6">
                        <img
                            className="margin-r-m"
                            src={require("../../img/for_edu/stu_diagrams@2x.png")}
                            width="40"
                            height="40"
                        />
                        <p className="weight-medium">
                            Build diagrams and <br />
                            infographics
                        </p>
                    </li>
                    <li className="idea-list-point display-flex col-lg-4 col-md-4 col-sm-6 col-xs-6">
                        <img
                            className="margin-r-m"
                            src={require("../../img/for_edu/stu_posters@2x.png")}
                            width="40"
                            height="40"
                        />
                        <p className="weight-medium">
                            Illustrate your club's posters and flyers
                        </p>
                    </li>
                    <li className="idea-list-point display-flex col-lg-4 col-md-4 col-sm-6 col-xs-6">
                        <img
                            className="margin-r-m"
                            src={require("../../img/for_edu/stu_maping@2x.png")}
                            width="40"
                            height="40"
                        />
                        <p className="weight-medium">
                            Use icons for <br />
                            story mapping
                        </p>
                    </li>
                    <li className="idea-list-point display-flex col-lg-4 col-md-4 col-sm-6 col-xs-6">
                        <img
                            className="margin-r-m"
                            src={require("../../img/for_edu/stu_cards@2x.png")}
                            width="40"
                            height="40"
                        />
                        <p className="weight-medium">
                            Create flashcards <br />
                            for studying
                        </p>
                    </li>
                    <li className="idea-list-point display-flex col-lg-4 col-md-4 col-sm-6 col-xs-6">
                        <img
                            className="margin-r-m"
                            src={require("../../img/for_edu/stu_labelsandsigns@2x.png")}
                            width="40"
                            height="40"
                        />
                        <p className="weight-medium">
                            Use icons for signs <br />
                            and labels
                        </p>
                    </li>
                    <li className="idea-list-point display-flex col-lg-4 col-md-4 col-sm-6 col-xs-6">
                        <img
                            className="margin-r-m"
                            src={require("../../img/for_edu/stu_research@2x.png")}
                            width="40"
                            height="40"
                        />
                        <p className="weight-medium">
                            Illustrate your research <br />
                            paper
                        </p>
                    </li>
                </ul>
                <div
                    className="margin-t-xl margin-b-xxl"
                    style={{
                        textAlign: "center"
                    }}
                >
                    <a
                        href="https://www.surveymonkey.com/r/5PTJMCD"
                        target="_blank"
                        className="text-link"
                    >
                        Tell us how you use icons for your student projects
                    </a>
                </div>
            </div>
        );

        return students;
    }

    renderCommonQuestions() {
        let commonQuestions;

        commonQuestions = (
            <div
                className="common-question-container row margin-b-xxl"
                style={{ borderTop: "solid 1px #ccc" }}
            >
                <div
                    className="col-xs-12 padding-t-xxl"
                    style={{ textAlign: "center" }}
                >
                    <style>{`
                        @media (max-width: 768px) {
                            .common-question-container {
                                padding: 0 24px;
                            }
                        }
                                `}</style>
                    <h2 className="font-large">Common Questions</h2>
                    <p>
                        Try our{" "}
                        <a
                            href="http://help.thenounproject.com"
                            target="_blank"
                            className="text-link"
                        >
                            help
                        </a>{" "}
                        page if you don't find your question answered here
                    </p>
                </div>

                <div className="col-sm-6 col-xs-12 margin-t-xl">
                    <h3 className="font-large weight-medium">
                        How do I qualify for an education discount?
                    </h3>
                    <p className="weight-light">
                        To get 50% off of NounPro, you must fill out the
                        application on this page. Once we verify your
                        information, we will send you an email confirming your
                        eligibility.
                    </p>
                </div>
                <div className="col-sm-6 col-xs-12 margin-t-xl">
                    <h3 className="font-large weight-medium">
                        What’s the difference between a paid and a free account?
                    </h3>
                    <p className="weight-light">
                        Both free and paid members get access to all the icons.
                        As a free member, you must give credit to the icon’s
                        designer each time you use their icon. NounPro members
                        get unlimited royalty-free licenses (no need to worry
                        about attribution), can download icons in any color, and
                        get access to all of our apps for quicker access.
                    </p>
                </div>
                <div className="col-sm-6 col-xs-12 margin-t-xl">
                    <h3 className="font-large weight-medium">
                        What information do I need to submit in the application?
                    </h3>
                    <p className="weight-light">
                        We ask that you include your email, occupation, and
                        school, as well as a quick description of how you plan
                        to use icons in your school work.
                    </p>
                </div>
                <div className="col-sm-6 col-xs-12 margin-t-xl">
                    <h3 className="font-large weight-medium">
                        How long does it normally take to get verified?
                    </h3>
                    <p className="weight-light">
                        It typically takes just a few hours to get verified,
                        however it can take up to a few days during the weekends
                        and holidays.
                    </p>
                </div>
                <div className="col-sm-6 col-xs-12 margin-t-xl">
                    <h3 className="font-large weight-medium">
                        Can I purchase photos with my subscription?
                    </h3>
                    <p className="weight-light">
                        No, at this time icon subscription plans apply only to
                        icon content (photos may be purchased separately).
                    </p>
                </div>
            </div>
        );

        return commonQuestions;
    }

    shuffle(a) {
        for (let i = a.length; i; i--) {
            let j = Math.floor(Math.random() * i);
            [a[i - 1], a[j]] = [a[j], a[i - 1]];
        }
    }

    renderTestimonials() {
        let testimonials,
            testimonialCards = [];

        this.state.testimonialData.forEach(card => {
            let imagePath = require("../../img/for_edu/testimonials/" +
                    card.imageName),
                quoteHTML = { __html: card.quote };

            testimonialCards.push(
                <li
                    className="testimonial-container col-lg-6 col-md-6 col-sm-6 col-xs-12 margin-t-xl"
                    key={card.name}
                >
                    <div className="testimonial">
                        <div className="testimonial-headshot">
                            <img src={imagePath} width="100" height="100" />
                        </div>
                        <quote
                            className="testimonial-quote font-medium weight-medium ui_quote"
                            dangerouslySetInnerHTML={quoteHTML}
                        />
                        <div style={{ color: COLORS.$grey }}>
                            <div className="testimonial-name weight-medium margin-t-xl">
                                {card.name}
                            </div>
                            <div className="testimonial-title weight-light">
                                {card.title}
                            </div>
                            <div className="testimonial-location weight-light">
                                {card.location}
                            </div>
                        </div>
                    </div>
                </li>
            );
        });

        testimonials = (
            <div className="container">
                <style>
                    {`
                        .testimonial{
                            border: solid 3px #F2F2F2;
                            text-align: center;
                            position: relative;
                            padding: 60px 48px 24px 48px;
                            min-height: 350px;
                            margin-top: 10px;
                            transition: all 0.3s ease-out;
                            top: 0;
                            display: flex;
                            flex-direction: column;
                            justify-content: space-between;
                        }
                        .testimonial-headshot{
                            position: absolute;
                            top: -50px;
                            left: 50%;
                            margin-left: -50px;
                            border-radius: 50%;
                            border: solid 3px #F2F2F2;
                            background-color: white;
                            overflow: hidden;
                            width: 100px;
                            height: 100px;
                        }
                        .testimonial-quote{
                            text-align: left;
                            display: block;
                            text-indent: -1.1em;
                        }
                        .testimonial-quote a{
                            border-bottom: solid 1px;
                        }
                        .testimonial-quote:before{
                            margin-right: 0.5em;
                            font-size: 14px;
                        }
                        .collection-list_arrow:not(.disabled):hover{
                            color: #000000;
                        }
                        @media (max-width: 768px) {
                            .column-reverse-on-mobile{
                                padding: 24px;
                                flex-direction: column-reverse;
                            }
                            .page-header-text-box{
                                padding: 24px;
                            }
                        }
                        @media (max-width: 1024px) {
                            .testimonial{
                                margin-top: 70px;
                            }
                            .testimonial-container:nth-child(n+3){
                                display: none;
                            }
                        }
                        `}
                </style>
                <ul className="slider-container row margin-t-xxl margin-b-xxl">
                    <Carousel
                        items={testimonialCards}
                        itemsPerView={2}
                        type={"testimonials"}
                    />
                </ul>
            </div>
        );

        return testimonials;
    }
}

function mapStateToProps(state, ownProps) {
    let currentUser;

    if (state.user.is_anonymous !== undefined) {
        currentUser = state.user;
    }

    return {
        currentUser
    };
}

export default connect(mapStateToProps, {
    getCurrentUser: actions.getCurrentUser
})(ForEdu);
